import type { InboxApproval } from '../types/approval.types';

interface Kind {
  label: string;
  /** Where the item lives, for "Open". */
  link: (approval: InboxApproval) => string;
  /** The link's text when "Open" says too little. */
  linkLabel?: string;
  /** The type's own decision endpoint, which enforces the rules. */
  decisionPath: (approvalId: number) => string;
}

/** Each approval type: its label, where it lives, and its decision endpoint. */
export const KINDS: Record<string, Kind> = {
  PricingParameterSet: {
    label: 'Pricing version',
    link: (a) => `/countries/${a.entityId}?tab=pricing`,
    linkLabel: 'Compare live and draft',
    decisionPath: (id) => `/admin/pricing/approvals/${id}`,
  },
  Refund: {
    label: 'Refund',
    link: (a) => `/orders/${a.entityId}`,
    decisionPath: (id) => `/admin/refunds/approvals/${id}`,
  },
  FxRateOverride: {
    label: 'Manual FX rate',
    link: () => '/countries',
    decisionPath: (id) => `/admin/market-approvals/${id}`,
  },
  PaymentChannelFees: {
    label: 'Payment channel fees',
    link: (a) => (a.countryId ? `/countries/${a.countryId}?tab=channels` : '/countries'),
    decisionPath: (id) => `/admin/market-approvals/${id}`,
  },
  ProviderBalanceAdjustment: {
    label: 'Provider balance',
    link: (a) => `/providers/${a.entityId}`,
    decisionPath: (id) => `/admin/providers/balance-approvals/${id}`,
  },
};

export const kindLabel = (type: string) => KINDS[type]?.label ?? type;
